import PlannerPersonModal from './PlannerPersonModal';

export default PlannerPersonModal;
